import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';
import { Header as NextStepsHeader } from './Header';
import { Step } from './Step';
import { useStepList } from './modules/useStepList';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function NextSteps({
  order,
  sharingId,
  adminURL,
  saveCreditCard
}) {
  const {
    __
  } = useTranslator();
  const steps = [...new Set(order.items.map(i => i.product_type))];
  if (saveCreditCard) {
    steps.push('credit-card');
  }
  const list = useStepList({
    adminURL,
    sharingId,
    steps,
    order
  });
  return list.length === 0 ? null : /*#__PURE__*/_jsxs("section", {
    children: [/*#__PURE__*/_jsx(NextStepsHeader, {
      children: __("Don't waste a minute: configure your products and start enjoying them now!")
    }), /*#__PURE__*/_jsx(Base, {
      flex: true,
      flexCol: true,
      flexAlignItemsStretch: true,
      gap: "spacing-3x",
      children: list.map(step => /*#__PURE__*/_jsx(Step, {
        iconName: step.iconName,
        title: step.title,
        url: step.url,
        children: step.children
      }, step.title))
    })]
  });
}